require(["jquery", "uiNotification", "partnerregisterhelper","jquery.unobtrusive-ajax", "jquery-validate", "jquery-validate-unobtrusive"],
    function ($, uiNotification, partnerregisterhelper) {

        var indexScript = function() {
            this.init();
        };

        indexScript.prototype.init = function() {

        };

        $(function() {
            uiNotification.init();
            uiNotification.loader(false);
            partnerregisterhelper.init();

            $(".requiredinput").on("input", function () {
               if ($(this).val().length > 0) {
                    $(this).removeClass("requiredinput");
                }
                else $(this).addClass("requiredinput");
            });

            $("#btnSubmit").on("click", function() {
                var isValid = $("#PartnerVerification").valid();
                if (isValid) {
                    uiNotification.loader(true);
                }
            });
        });
    });